export default __webpack_public_path__ + "static/media/gallery_5.aa0ebb5f.jpeg";